import React from "react";
import {
  FiChevronLeft,
  FiChevronRight,
  FiDownload,
  FiRefreshCw,
} from "react-icons/fi";

const VIEW_OPTIONS = [
  { value: "week", label: "สัปดาห์" },
  { value: "month", label: "เดือน" },
];

const TimesheetDashboardToolbar = ({
  viewMode,
  rangeLabel,
  loading,
  onViewChange,
  onPrevious,
  onNext,
  onRefresh,
  onExport,
  exporting = false,
}) => {
  return (
    <div className="grid gap-4 lg:grid-cols-[auto,1fr,auto] lg:items-center">
      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-1 inline-flex w-full sm:w-auto">
        {VIEW_OPTIONS.map((option) => {
          const active = option.value === viewMode;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onViewChange(option.value)}
              className={[
                "flex-1 sm:flex-none rounded-xl px-4 py-2 text-sm font-medium transition",
                active
                  ? "bg-indigo-500 text-white shadow-sm"
                  : "text-gray-600 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-300",
              ].join(" ")}
            >
              {option.label}
            </button>
          );
        })}
      </div>

      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-3 flex items-center justify-between gap-3">
        <button
          type="button"
          onClick={onPrevious}
          className="inline-flex items-center gap-2 rounded-xl border border-gray-200 dark:border-gray-700 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:border-indigo-300 dark:hover:border-indigo-700"
        >
          <FiChevronLeft />
          ก่อนหน้า
        </button>

        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.18em] text-gray-400 dark:text-gray-500">
            ช่วงวันที่
          </p>
          <p className="text-sm sm:text-base font-semibold text-gray-900 dark:text-gray-100">
            {rangeLabel}
          </p>
        </div>

        <button
          type="button"
          onClick={onNext}
          className="inline-flex items-center gap-2 rounded-xl border border-gray-200 dark:border-gray-700 px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:border-indigo-300 dark:hover:border-indigo-700"
        >
          ถัดไป
          <FiChevronRight />
        </button>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row lg:flex-col xl:flex-row">
        <button
          type="button"
          onClick={onRefresh}
          disabled={loading || exporting}
          className="inline-flex items-center justify-center gap-2 rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-3 text-sm font-medium text-gray-700 dark:text-gray-200 hover:border-indigo-300 dark:hover:border-indigo-700 transition disabled:opacity-60"
        >
          <FiRefreshCw className={loading ? "animate-spin" : ""} />
          รีเฟรช
        </button>
        <button
          type="button"
          onClick={onExport}
          disabled={loading || exporting}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-medium text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <FiDownload />
          {exporting ? "กำลัง Export..." : "Export Excel"}
        </button>
      </div>
    </div>
  );
};

export default TimesheetDashboardToolbar;
